import { AppForm } from '../../../../../../../common/forms/app.form';
import { Injectable } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ApplicationAppEntityApplicationRead } from '../../../../../../../openapi';
import { CustomValidator, fromToDate } from '../../../../../../../common/forms/custom.validators';

@Injectable()
export class CancellationDataForm extends AppForm {

  public appealSubjects: string[] = [
    'Całości decyzji',
    'Części decyzji'
  ];

  public appealRequests: string[] = [
    'Zmianę decyzji i orzeczenie co do istoty sprawy',
    'Uchylenie decyzji',
    'Przekazania sprawy do ponownego rozpoznania przez organ I Instancji',
    'Inne'
  ];

  constructor() {
    super({
      decisionDate: new FormControl(null, { validators: [Validators.required, CustomValidator.isValidDateFormat(), CustomValidator.maxDate(new Date())] }),
      decisionDeliveryDate: new FormControl(null, { validators: [Validators.required, CustomValidator.isValidDateFormat(), CustomValidator.maxDate(new Date())] }),
      appealContent: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(5000)]
      }),
      appealSubject: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(255)]
      }),
      appealRequest: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(255)]
      })
    }, {
      validators: [fromToDate('decisionDate', 'decisionDeliveryDate')]
    });
  }

  public get appealSubjectDescription(): FormControl | null {
    return this.get('appealSubjectDescription') as FormControl | null;
  }

  public get appealRequestDescription(): FormControl | null {
    return this.get('appealRequestDescription') as FormControl | null;
  }

  public appealSubjectChange(v: string): void {
    if (v === 'Części decyzji') {
      this.addControl('appealSubjectDescription', new FormControl('', {
          nonNullable: true,
          validators: [Validators.required, Validators.maxLength(5000)]
        })
      );
    } else {
      this.removeControl('appealSubjectDescription');
    }
  }

  public appealRequestChange(v: string): void {
    if (v === 'Inne') {
      this.addControl('appealRequestDescription', new FormControl('', {
          nonNullable: true,
          validators: [Validators.required, Validators.maxLength(5000)]
        })
      );
    } else {
      this.removeControl('appealRequestDescription');
    }
  }

  public override patchFormValues(value: ApplicationAppEntityApplicationRead): void {
    super.patchFormValues(value);
    this.appealSubjectChange(value?.appealSubject || '');
    this.appealSubjectDescription?.setValue(value?.appealSubjectDescription);
    this.appealRequestChange(value?.appealRequest || '');
    this.appealRequestDescription?.setValue(value?.appealRequestDescription);
  }
}
